import { useCallback, useEffect } from 'react';

import { isMessagePost } from '@web/conversations/utils/guards';
import {
  useConversationActions,
  useConversationState,
} from '@web/conversations/Conversation/ConversationProvider/ConversationProvider';

export enum KEY {
  ARROW_UP = 'ArrowUp',
}

export const useEditMessageKeyListener = () => {
  const { editMessageId, messages } = useConversationState();
  const { setEditMessage } = useConversationActions();

  const onArrowUp = useCallback(() => {
    if (editMessageId) return;

    const { allIds, byId } = messages;

    const newestOwnMessageId = allIds.find((id) => {
      const message = byId[id];

      return isMessagePost(message) && message.author.isMe && !message.isDeleted;
    });
    setEditMessage({ messageId: newestOwnMessageId });
  }, [editMessageId, messages, setEditMessage]);

  useEffect(() => {
    const listener = (event: KeyboardEvent) => {
      if (event.key === KEY.ARROW_UP) {
        onArrowUp();
      }
    };

    document.addEventListener('keydown', listener);

    return () => {
      document.removeEventListener('keydown', listener);
    };
  }, [onArrowUp]);
};
